import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme, useThemeUpdate } from '../../contexts/ThemeContext';
import palette from '../../assets/icons/palette.svg';
import logo from '../../assets/logo/pal-logo.png';
import palettedark from '../../assets/icons/palette-dark.svg';
import Toggle from '../Toggle/Toggle';

import './Header.scss';

export default function Header({match}) {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false)
    const { currentUser, logout } = useAuth();
    const darkTheme = useTheme();
    const toggleTheme = useThemeUpdate();

    const history = useHistory();

    const handleLogout = async () => {
        setError('');
        try {
            await logout()
            setLoading(true)
            history.push('/');
        } catch (err){
            console.log(err)
            setError('Failed to log out')
        }
        setLoading(false);
    }
   
    return (
        <div className={(darkTheme) ? "header-dark" : "header"}>
            
            <Link to="/" className={(darkTheme) ? "header__title-dark" : "header__title"}><img className="header__logo" src={logo} alt="palette. logo"/><h1>palette.</h1></Link>
            {(currentUser) 
            ? 
            <div className="header__user">

            <h4 className="header__email">Hello {currentUser.email}</h4>
            <Toggle setTheme={toggleTheme}/>
            <Link to="/dash"><div className={(darkTheme) ? "header__dash-dark" : "header__dash"}><img src={(darkTheme) ? palettedark : palette} alt="palette button"/></div></Link>
            <button disabled={loading} className={(darkTheme) ? "header__btn-dark" : "header__btn"} onClick={handleLogout}>Log Out</button>
            {(error) ? <p>{error}</p> : null}
            </div> 
            :
            <nav>
                <ul className="header__nav">
                    <Toggle setTheme={toggleTheme}/>
                    <Link className={(darkTheme) ? "header__title-dark" : "header__title"} to="/signup"><li className="header__nav-item">Sign Up</li></Link>
                    <Link className={(darkTheme) ? "header__title-dark" : "header__title"} to="/login"><li className="header__nav-item">Login</li></Link>
                </ul>
            </nav>
            }
            
        </div>
    )
}
